import React from 'react';
import styles from './Contact.module.css';
import { personal } from '../data/portfolio';

const contactLinks = [
  {
    label: 'Email me',
    href: `mailto:${personal.email}`,
    icon: (
      <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
        <rect x="1" y="3" width="13" height="9" rx="1.5" stroke="currentColor" strokeWidth="1.2"/>
        <path d="M1 4l6.5 4.5L14 4" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/>
      </svg>
    ),
  },
  {
    label: 'GitHub',
    href: personal.links.github,
    icon: (
      <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
        <path d="M7.5 1C3.91 1 1 3.91 1 7.5c0 2.87 1.86 5.3 4.44 6.16.32.06.44-.14.44-.31v-1.1c-1.8.39-2.18-.87-2.18-.87-.3-.76-.73-1-.73-1-.6-.4.04-.4.04-.4.66.05 1.01.68 1.01.68.59 1.01 1.55.72 1.93.55.06-.43.23-.72.42-.89-1.44-.16-2.95-.72-2.95-3.2 0-.71.25-1.29.68-1.74-.07-.17-.3-.83.06-1.72 0 0 .55-.18 1.8.68A6.3 6.3 0 017.5 4c.56 0 1.12.07 1.65.22 1.24-.86 1.8-.68 1.8-.68.36.89.13 1.55.06 1.72.43.45.68 1.03.68 1.74 0 2.49-1.52 3.04-2.96 3.2.23.2.44.6.44 1.2v1.79c0 .17.11.37.44.31A6.502 6.502 0 0014 7.5C14 3.91 11.09 1 7.5 1z" fill="currentColor"/>
      </svg>
    ),
  },
  {
    label: 'LinkedIn',
    href: personal.links.linkedin,
    icon: (
      <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
        <rect x="1" y="1" width="13" height="13" rx="2" stroke="currentColor" strokeWidth="1.2"/>
        <path d="M4 6v5M4 4v.5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"/>
        <path d="M7.5 11V8a1.5 1.5 0 013 0v3M7.5 6v1" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/>
      </svg>
    ),
  },
  {
    label: 'LeetCode',
    href: personal.links.leetcode,
    icon: (
      <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
        <path d="M3 7.5h9M10 4.5l2.5 3-2.5 3" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
  },
];

export default function Contact() {
  return (
    <div className="stack fade-in">
      <div className="stack-inner">
        <div className={styles.inner}>
          <h3 className={styles.heading}>Let's build something.</h3>
          <p className={styles.sub}>Open to full-time roles, internships, and interesting collaborations.</p>
          <div className={styles.links}>
            {contactLinks.map((l) => (
              <a key={l.label} href={l.href} className={styles.link} target={l.href.startsWith('mailto') ? undefined : '_blank'} rel="noreferrer">
                {l.icon}
                {l.label}
              </a>
            ))}
          </div>
          <a href={`mailto:${personal.email}`} className={styles.email}>{personal.email}</a>
        </div>
      </div>
    </div>
  );
}
